export enum USER_PROFILE_FIELD_NAME {
	NAME = 'firstName',
	SURNAME = 'lastName',
	MIDDLE_NAME = 'middleName',
	TAX_ID = 'taxId',
	EMAIL = 'email',
	CHANGE = 'change-pin-code',
}

export const EDIT_USER_FIRST_NAME = { title: 'Вкажіть ваше ім’я', label: 'Ім’я', name: USER_PROFILE_FIELD_NAME.NAME };

export const EDIT_USER_LAST_NAME = {
	title: 'Вкажіть ваше прізвище',
	label: 'Прізвище',
	name: USER_PROFILE_FIELD_NAME.SURNAME,
};

export const EDIT_USER_MIDDLE_NAME = {
	title: 'Вкажіть ваше по батькові',
	label: 'По батькові',
	name: USER_PROFILE_FIELD_NAME.MIDDLE_NAME,
};

export const EDIT_USER_TAX_ID = {
	title: 'Вкажіть ваш ІПН (РНОКПП)',
	label: 'ІПН (РНОКПП)',
	name: USER_PROFILE_FIELD_NAME.TAX_ID,
};

export const EDIT_USER_EMAIL = {
	title: 'Вкажіть ваш email',
	label: 'Email',
	name: USER_PROFILE_FIELD_NAME.EMAIL,
};
